import { chipColours, corePalette } from '@/themes/colours';
import { ICurrentCaseStatus } from '@/types/TaskDashboard/TaskDashboard.types';

export const pseudoStatuses = [
  'N/A',
  'On Hold',
] as const;

export const onHoldStatus: ICurrentCaseStatus = {
  status: 'On Hold',
  chipProps: {
    status: 'On Hold',
    color: chipColours.chipRedText,
    backgroundColor: chipColours.chipRedBg,
  },
};

export const naStatus: ICurrentCaseStatus = {
  status: 'N/A',
  chipProps: {
    status: 'N/A',
    color: chipColours.chipGreyText,
    backgroundColor: chipColours.chipGreyBg,
    background: `repeating-linear-gradient(45deg, ${corePalette.grey50}, ${corePalette.grey50} 3px, ${corePalette.grey30} 3px, ${corePalette.grey30} 6px)`,
  },
};

export const pseudoStatusesMap = {
  'On Hold': onHoldStatus,
  'N/A': naStatus,
};
